export const is_null = obj => obj == null || obj == undefined
